export default {
    LOW: 'low',
    HIGH: 'high',
};
